import $ from 'jquery';
import { breakpoints } from './_site';
import Mustache from '../../../_lib/plugins/mustache/mustache';
import { createAlert } from './window';
import { getData, validatefields } from './form';

export const timeout = {};
export const responsiveSearch = (flag) => {
    var $search = $('.search-modal');

    if($search.length) {
        if (flag) {
            $search.css({ width: 'auto', display: '' });
        } else {
            $search
                .show()
                .css({ width: $(window).width() - $search.offset().left })
                .hide();
        }
    }
};
export const resize = () => {
    var $window = $(window);

    // md
    if ($window.width() < breakpoints.md) {
        responsiveSearch(true);
    } else {
        responsiveSearch(false);
    }
};
export const highlightText = (text, term) => {
    term = term.replace(/(\s+)/, '(<[^>]+>)*$1(<[^>]+>)*');
    const pattern = new RegExp('(' + term + ')', 'gi');

    text = text.replace(pattern, '<strong>$1</strong>');
    text = text.replace(
        /(<strong>[^<>]*)((<[^>]+>)+)([^<>]*<\/strong>)/,
        '$1</strong>$2<strong>$4'
    );

    return text;
};
export const searchResultDesktopTemplate = () => {
    return '\
    <li class="search-modal__list__item">\
        <a href="{{link}}" class="search-modal__list__link">\
            <span class="search-modal__list__keyword">{{&title}}</span>\
        </a>\
    </li>';
};
export const renderResult = (data, keyword) => {
    let templateDesktop = searchResultDesktopTemplate(),
        $searchResultDesktop = $('#search-result--desktop'),
        $searchResultDesktopEmpty = $searchResultDesktop.find(
            '.search-modal__empty'
        ),
        $searchResultDesktopList = $searchResultDesktop.find(
            '.search-modal__list'
        );

    $searchResultDesktop.show();

    if (typeof data.list != 'undefined' && data.list.length) {
        $searchResultDesktopEmpty.hide();

        // Flush list
        $searchResultDesktopList.html('');

        data.list.map((item) => {
            // Highlight
            if (keyword) {
                item.title = highlightText(item.title, keyword);
            }

            // Desktop render
            let $item = Mustache.render(templateDesktop, item);

            $searchResultDesktopList.append($item);
        });

        $searchResultDesktopList.show();
    } else {
        $searchResultDesktopEmpty.show();
        $searchResultDesktopList.hide();
    }
};
export const resetSearchForm = ($el) => {
    var $form = $el.closest('.form');

    $form[0].reset();
};
export const send = ($el) => {
    var $form = $el,
        // keyword = $form.find('[name=keyword]').val(),
        url = $form.data('action'),
        data = getData($form);
    // spinner = $.extend(true, {}, spin);

    // spinner.color = '#000000';

    function toggleLoader(flag) {
        if (flag) {
            // add loader
            // $submit.addClass(submitClass + '--loading');
            // $submitAux.spin(spinner);
        } else {
            // remove loader
            // $submit.removeClass(submitClass + '--loading');
            // $submitAux.spin(false);
        }
    }

    // prevent multiple clicks
    // if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    //     return false;
    // }

    console.log(data);

    // validation errors
    if (!validatefields($form, true)) {
        return false;
    }

    // send data
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        cache: false,
        dataType: 'json',
        beforeSend: function() {
            // add loader
            toggleLoader(true);
        },
        success: function(response) {
            console.log(response);

            if (response.status) {
                // segment tracking
                // if (typeof(response.segment) !== 'undefined' && response.segment) {
                //     SegmentTracking.trigger(response.segment);
                // }
                // if (response.message) {
                //     // create alert
                //     createAlert(response, 'success');
                // }
                if (response.url) {
                    window.location.href = response.url;
                    return;
                }

                // renderResult(response, keyword);
            } else {
                // create alert
                createAlert(response, 'error');
            }

            // remove loader
            toggleLoader(false);
        },
        error: function(response) {
            // create alert
            createAlert(response, 'error');
            // remove loader
            toggleLoader(false);
        },
    });
};
export const toggleSearchModal = () => {
    if ($('body').hasClass('search-active')) {
        hideSearchModal();
    } else {
        showSearchModal();
    }
};
export const showSearchModal = () => {
    let $searchModal = $('.search-modal');

    if ($searchModal.length) {
        $('body').removeClass('cart-active');
        $('body').addClass('search-active');
        $searchModal.fadeIn('fast');

        // Force focus
        $searchModal.find('input').focus();
    }
};
export const hideSearchModal = () => {
    let $searchModal = $('.search-modal');

    if ($searchModal.length) {
        $('body').removeClass('search-active menu-active');
        $searchModal.fadeOut('fast');
    }
};
export const binds = () => {
    // ---------------- menu (responsive)
    $('#wrapper').on('click.toggle-search', '[data-toggle-search]', function(
        event
    ) {
        toggleSearchModal();
        event.preventDefault();
    });

    $('#backdrop').on('click.toggle-search', function(event) {
        hideSearchModal();
    });

    $('#wrapper').on('submit.search', '[data-search-form]', function(event) {
        send($(this));
        event.preventDefault();
    });

    $('#wrapper').on('click', '.search-modal__form [data-reset-form]', function(
        event
    ) {
        resetSearchForm($(this));
        event.preventDefault();
    });

    // ---------------- window events
    $(window).on('resize.menu', function() {
        clearTimeout(timeout.searchResize);
        timeout.searchResize = setTimeout(function() {
            resize();
        }, 100);
    });
    $(window).triggerHandler('resize.menu');
};
